// extracted by mini-css-extract-plugin
module.exports = {"title":"_3CQhMv5-","message":"_35NMiSnT"};